import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=cd88aa6a&scoped=true"
import script from "./ChatBox.vue?vue&type=script&lang=ts"
export * from "./ChatBox.vue?vue&type=script&lang=ts"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=cd88aa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd88aa6a",
  null
  
)

export default component.exports